import { defineMessages } from 'react-intl';

type MessageKeys = 'noSkills' | 'noTools';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noSkills: {
			id: 'rovo-chat.view-agent.no-skills',
			defaultMessage: 'No skills',
			description: 'Text to display when there are no skills for the agent',
		},
		noTools: {
			id: 'rovo-chat.view-agent.no-tools',
			defaultMessage: 'No tools',
			description: 'Text to display when there are no tools for the agent',
		},
	});

export default message;
